module.exports = __webpack_public_path__ + "media/images/icons/outlined/reddit-6d17444dcedb0f86096466595fba0201.svg";